import { authApiUrl, accessTokenKey, authApiVersion } from "../config";
import apiPath from "../utils/apiPath";
import BaseConnector, { serializeEntity } from "./baseConnector";

export interface AuthConnectorOptions {
  customVersion?: string;
}

export default class AuthConnector extends BaseConnector {
  constructor(options: AuthConnectorOptions = {}) {
    const versionPath = apiPath(options.customVersion ?? authApiVersion);
    const url = `${authApiUrl}/${versionPath}`;
    super(url, accessTokenKey, serializeEntity);
  }

  static Factory() {
    return (options?: AuthConnectorOptions) => new AuthConnector(options);
  }
}
